export enum APIResponseStatusType {
  SUCCESS = 'success',
  FAIL = 'fail',
  ERROR = 'error',
  UNAUTHORIZED = 'Unauthorized.',
}
